export default __webpack_public_path__ + "static/media/I0000.2b4ddeac.png";